"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tryFocus = exports.focusPrev = exports.focusNext = exports.getActiveElement = void 0;
var getActiveElement = function (element) {
    if (typeof window === 'undefined')
        return null;
    var currentActive = element !== null && element !== void 0 ? element : document.activeElement;
    var shadowRoot = currentActive.shadowRoot;
    var contentDocument = currentActive
        .contentDocument;
    if (shadowRoot === null || shadowRoot === void 0 ? void 0 : shadowRoot.activeElement)
        return exports.getActiveElement(shadowRoot.activeElement);
    if (contentDocument === null || contentDocument === void 0 ? void 0 : contentDocument.activeElement)
        return exports.getActiveElement(contentDocument.activeElement);
    return currentActive;
};
exports.getActiveElement = getActiveElement;
var getActiveIndex = function (tabbables) {
    return tabbables.indexOf(exports.getActiveElement());
};
var focusNext = function (tabbables) {
    var nextNode = tabbables[getActiveIndex(tabbables) + 1] || tabbables[0];
    exports.tryFocus(nextNode);
};
exports.focusNext = focusNext;
var focusPrev = function (tabbables) {
    var prevNode = tabbables[getActiveIndex(tabbables) - 1] ||
        tabbables[tabbables.length - 1];
    exports.tryFocus(prevNode);
};
exports.focusPrev = focusPrev;
var tryFocus = function (el) {
    if (el === document.activeElement)
        return;
    if (!el || !el.focus) {
        return;
    }
    el.focus({ preventScroll: true }); // Configurable
    if (isSelectableInput(el)) {
        el.select();
    }
};
exports.tryFocus = tryFocus;
var isSelectableInput = function (el) {
    var _a;
    return ((_a = el.tagName) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'input' &&
        typeof el.select === 'function';
};
//# sourceMappingURL=focus-utils.js.map